// import React, { useEffect, useRef, useState } from "react";
// import { APILog, LogsResponse } from "../types";
// import StatusBadge from "../components/StatusBadge";
// import { PageHeader, Loader, ErrorMsg, refreshBtnStyle } from "../components/Common";
// import * as XLSX from "xlsx";
// const LIMIT = 50;

// // ── Debounce hook ──────────────────────────────────────────
// function useDebounce<T>(value: T, delay: number): T {
//   const [debounced, setDebounced] = useState(value);
//   useEffect(() => {
//     const t = setTimeout(() => setDebounced(value), delay);
//     return () => clearTimeout(t);
//   }, [value, delay]);
//   return debounced;
// }

// // ── Filter sub-components ──────────────────────────────────
// const FilterInput: React.FC<{
//   value: string;
//   onChange: (v: string) => void;
//   placeholder?: string;
// }> = ({ value, onChange, placeholder }) => (
//   <input
//     value={value}
//     onChange={(e) => onChange(e.target.value)}
//     placeholder={placeholder}
//     style={filterInputStyle}
//   />
// );

// const FilterSelect: React.FC<{
//   value: string;
//   onChange: (v: string) => void;
//   options: string[];
// }> = ({ value, onChange, options }) => (
//   <select value={value} onChange={(e) => onChange(e.target.value)} style={filterInputStyle}>
//     {options.map((o) => (
//       <option key={o} value={o}>{o || "All"}</option>
//     ))}
//   </select>
// );

// // ── Page ───────────────────────────────────────────────────
// const LogFeedPage: React.FC = () => {
//   const [logs, setLogs]     = useState<APILog[]>([]);
//   const [total, setTotal]   = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [error, setError]   = useState<string | null>(null);
//   const [live, setLive]     = useState(false);
//   const [skip, setSkip]     = useState(0);
//   const [timeZone, setTimeZone] = useState<"UTC" | "IST">("UTC");

//   // Raw filter state
//   const [status,       setStatus]       = useState("");
//   const [endpoint,     setEndpoint]     = useState("");
//   const [userType,     setUserType]     = useState("");
//   const [method,       setMethod]       = useState("");
//   const [schoolCode,   setSchoolCode]   = useState("");
//   const [priority,     setPriority]     = useState("");
//   const [actionStatus, setActionStatus] = useState("");

//   // Debounced (500ms) — avoids hammering the API on every keystroke
//   const dStatus       = useDebounce(status,       500);
//   const dEndpoint     = useDebounce(endpoint,     500);
//   const dUserType     = useDebounce(userType,     500);
//   const dMethod       = useDebounce(method,       500);
//   const dSchoolCode   = useDebounce(schoolCode,   500);
//   const dPriority     = useDebounce(priority,     500);
//   const dActionStatus = useDebounce(actionStatus, 500);

//   const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

//   const buildParams = (s = skip): Record<string, string | number> => {
//     const p: Record<string, string | number> = { limit: LIMIT, skip: s };
//     if (dStatus)       p.status        = dStatus;
//     if (dEndpoint)     p.endpoint      = dEndpoint;
//     if (dUserType)     p.user_type     = dUserType;
//     if (dMethod)       p.method        = dMethod;
//     if (dSchoolCode)   p.school_code   = dSchoolCode;
//     if (dPriority)     p.priority      = dPriority;
//     if (dActionStatus) p.action_status = dActionStatus;
//     return p;
//   };

//   const load = (s = skip) => {
//     setLoading(true);
//       .then((res) => { setLogs(res.logs); setTotal(res.total); setError(null); })
//       .catch((e) => setError(e.message))
//       .finally(() => setLoading(false));
//   };

//   // Re-fetch when debounced filters change
//   useEffect(() => {
//     setSkip(0);
//     load(0);
//   }, [dStatus, dEndpoint, dUserType, dMethod, dSchoolCode, dPriority, dActionStatus]); // eslint-disable-line

//   // Live polling
//   useEffect(() => {
//     if (live) {
//       intervalRef.current = setInterval(() => load(0), 5000);
//     } else {
//       if (intervalRef.current) clearInterval(intervalRef.current);
//     }
//     return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
//   }, [live, dStatus, dEndpoint, dUserType, dMethod, dSchoolCode, dPriority, dActionStatus]); // eslint-disable-line

//   const totalPages  = Math.ceil(total / LIMIT);
//   const currentPage = Math.floor(skip / LIMIT) + 1;

//   const formatDateTime = (dateString: string) => {
//     const date = new Date(dateString);
//     if (timeZone === "IST") {
//       return new Date(date.getTime() + 5.5 * 3600_000).toLocaleString("en-IN", { hour12: true });
//     }
//     return date.toLocaleString("en-US", { hour12: true }) + " UTC";
//   };

//   const clearFilters = () => {
//     setStatus(""); setEndpoint(""); setUserType(""); setMethod("");
//     setSchoolCode(""); setPriority(""); setActionStatus("");
//   };


//   const downloadExcel = () => {
//   const exportData = logs.map((log) => ({
//     DateTime: formatDateTime(log.datetime),
//     School: log.school_code || "",
//     Family: log.family_code || "",
//     Login: log.login || "",
//     UserType: log.user_type || "",
//     Method: log.method || "",
//     Endpoint: log.endpoint || "",
//     Status: log.status || "",
//     StatusCode: log.status_code || "",
//     ResponseTimeMs: log.response_time_ms || "",
//     Priority: log.priority || "",
//     ActionStatus: log.action_status || "",
//   }));

//   const worksheet = XLSX.utils.json_to_sheet(exportData);
//   const workbook = XLSX.utils.book_new();

//   XLSX.utils.book_append_sheet(workbook, worksheet, "Logs");

//   XLSX.writeFile(
//     workbook,
//     `logs_${new Date().toISOString().slice(0, 10)}.xlsx`
//   );
// };

//   if (loading) return <Loader />;
//   if (error)   return <ErrorMsg msg={error} onRetry={() => load()} />;

//   return (
//     <div>
//       <PageHeader title="Live Log Feed" subtitle="Every API call logged in real time" />

//       {/* Toolbar */}
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, flexWrap: "wrap", gap: 8 }}>
//         <span style={{ fontSize: 13, color: "var(--muted)" }}>
//           Showing {logs.length} of {total.toLocaleString()} logs
//         </span>
//         <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
//           {/* Timezone */}
//           <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//             <span style={{ fontSize: 12, color: "var(--muted)" }}>Time Zone:</span>
//             <select
//               value={timeZone}
//               onChange={(e) => setTimeZone(e.target.value as "UTC" | "IST")}
//               style={{ ...filterInputStyle, padding: "6px 10px" }}
//             >
//               <option value="UTC">UTC</option>
//               <option value="IST">India (UTC +5:30)</option>
//             </select>
//           </div>
//           <button
//   onClick={downloadExcel}
//   style={{
//     ...refreshBtnStyle,
//     background: "#16a34a",
//     color: "#fff",
//   }}
// >
//   ⬇ Download Excel
// </button>
//           <button
//             onClick={() => setLive((v) => !v)}
//             style={{
//               ...refreshBtnStyle,
//               background: live ? "var(--success)" : "var(--surface)",
//               color: live ? "#fff" : "var(--text)",
//               border: "1px solid var(--border)",
//             }}
//           >
//             {live ? "● Live" : "○ Live off"}
//           </button>
//           <button onClick={clearFilters} style={{ ...refreshBtnStyle, background: "var(--surface)", color: "var(--text)", border: "1px solid var(--border)" }}>
//             Clear Filters
//           </button>
//           <button onClick={() => load()} style={refreshBtnStyle}>↻ Refresh</button>
//         </div>
//       </div>

//       {/* Table */}
//       <div style={{ background: "var(--surface)", borderRadius: 10, border: "1px solid var(--border)", overflow: "hidden" }}>
//         <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: 680 }}>
//           <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
//             <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
//               {/* Filter row */}
//               <tr style={{ background: "var(--surface-soft)" }}>
//                 <th style={th}></th>
//                 <th style={th}><FilterInput value={schoolCode} onChange={setSchoolCode} placeholder="School…" /></th>
//                 <th style={th}></th>
//                 <th style={th}></th>
//                 <th style={th}><FilterSelect value={userType} onChange={setUserType} options={["", "Admin", "Tutor"]} /></th>
//                 <th style={th}><FilterSelect value={method} onChange={setMethod} options={["", "GET", "POST", "PUT", "DELETE"]} /></th>
//                 <th style={th}><FilterInput value={endpoint} onChange={setEndpoint} placeholder="Endpoint…" /></th>
//                 <th style={th}><FilterSelect value={status} onChange={setStatus} options={["", "success", "failed"]} /></th>
//                 <th style={th}></th>
//                 <th style={th}></th>
//                 <th style={th}><FilterSelect value={priority} onChange={setPriority} options={["", "High", "Medium", "Low"]} /></th>
//                 <th style={th}><FilterSelect value={actionStatus} onChange={setActionStatus} options={["", "Pending", "Resolved", "Ignored"]} /></th>
//               </tr>
//               {/* Label row */}
//               <tr style={{ background: "var(--surface-soft)", borderBottom: "1px solid var(--border)" }}>
//                 {["DateTime", "School", "Family", "Login", "User Type", "Method", "Endpoint", "Status", "Code", "RT(ms)", "Priority", "Action"].map((h) => (
//                   <th key={h} style={{ ...th, color: "var(--muted)", fontWeight: 600, letterSpacing: "0.04em" }}>{h}</th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {logs.length === 0 ? (
//                 <tr><td colSpan={12} style={{ padding: 32, textAlign: "center", color: "var(--muted)" }}>No logs found</td></tr>
//               ) : logs.map((log) => (
//                 <tr key={log._id} style={{ borderBottom: "1px solid var(--border)" }}>
//                   <td style={td}>{formatDateTime(log.datetime)}</td>
//                   <td style={td}>{log.school_code || "—"}</td>
//                   <td style={td}>{log.family_code || "—"}</td>
//                   <td style={td}>{log.login       || "—"}</td>
//                   <td style={td}>{log.user_type   || "—"}</td>
//                   <td style={td}><StatusBadge value={log.method}      type="method"      /></td>
//                   <td style={{ ...td, fontFamily: "monospace", maxWidth: 220, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{log.endpoint}</td>
//                   <td style={td}><StatusBadge value={log.status}      type="status"      /></td>
//                   <td style={td}><StatusBadge value={log.status_code} type="status_code" /></td>
//                   <td style={{ ...td, color: log.response_time_ms > 1000 ? "#f87171" : "var(--muted)" }}>{log.response_time_ms}</td>
//                   <td style={td}>{log.priority      ? <StatusBadge value={log.priority}      type="priority"      /> : "—"}</td>
//                   <td style={td}>{log.action_status ? <StatusBadge value={log.action_status} type="action_status" /> : "—"}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         {totalPages > 1 && (
//           <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 10, padding: 14, borderTop: "1px solid var(--border)" }}>
//             <button
//               disabled={currentPage === 1}
//               onClick={() => { const s = skip - LIMIT; setSkip(s); load(s); }}
//               style={{ ...refreshBtnStyle, opacity: currentPage === 1 ? 0.4 : 1 }}
//             >← Prev</button>
//             <span style={{ fontSize: 13, color: "var(--muted)" }}>Page {currentPage} of {totalPages}</span>
//             <button
//               disabled={currentPage === totalPages}
//               onClick={() => { const s = skip + LIMIT; setSkip(s); load(s); }}
//               style={{ ...refreshBtnStyle, opacity: currentPage === totalPages ? 0.4 : 1 }}
//             >Next →</button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default LogFeedPage;

// const th: React.CSSProperties = { padding: "8px 12px", textAlign: "left", fontSize: 11, whiteSpace: "nowrap" };
// const td: React.CSSProperties = { padding: "9px 12px", color: "var(--muted)", whiteSpace: "nowrap" };
// const filterInputStyle: React.CSSProperties = {
//   width: "100%",
//   background: "var(--surface)",
//   border: "1px solid var(--border)",
//   borderRadius: 5,
//   padding: "5px 8px",
//   color: "var(--text)",
//   fontSize: 11,
//   outline: "none",
//   boxSizing: "border-box",
// };




// import React, { useEffect, useRef, useState } from "react";
// import { APILog, LogsResponse } from "../types";
// import StatusBadge from "../components/StatusBadge";
// import { PageHeader, Loader, ErrorMsg, refreshBtnStyle } from "../components/Common";
// import * as XLSX from "xlsx";

// // ── Default date range: today, and 1 month ago ──────────────
// const toDateInputValue = (d: Date): string => d.toISOString().slice(0, 10);

// const getDefaultDateRange = (): { from: string; to: string } => {
//   const to = new Date();
//   const from = new Date();
//   from.setMonth(from.getMonth() - 1);
//   return { from: toDateInputValue(from), to: toDateInputValue(to) };
// };

// // ── Debounce hook ──────────────────────────────────────────
// function useDebounce<T>(value: T, delay: number): T {
//   const [debounced, setDebounced] = useState(value);
//   useEffect(() => {
//     const t = setTimeout(() => setDebounced(value), delay);
//     return () => clearTimeout(t);
//   }, [value, delay]);
//   return debounced;
// }

// // ── Filter sub-components ──────────────────────────────────
// const FilterInput: React.FC<{
//   value: string;
//   onChange: (v: string) => void;
//   placeholder?: string;
// }> = ({ value, onChange, placeholder }) => (
//   <input
//     value={value}
//     onChange={(e) => onChange(e.target.value)}
//     placeholder={placeholder}
//     style={filterInputStyle}
//   />
// );

// const FilterSelect: React.FC<{
//   value: string;
//   onChange: (v: string) => void;
//   options: string[];
// }> = ({ value, onChange, options }) => (
//   <select value={value} onChange={(e) => onChange(e.target.value)} style={filterInputStyle}>
//     {options.map((o) => (
//       <option key={o} value={o}>{o || "All"}</option>
//     ))}
//   </select>
// );

// // ── Page ───────────────────────────────────────────────────
// const LogFeedPage: React.FC = () => {
//   const [logs, setLogs]     = useState<APILog[]>([]);
//   const [total, setTotal]   = useState(0);
//   const [loading, setLoading]     = useState(true);   // true only for the very first load
//   const [refreshing, setRefreshing] = useState(false); // true for filter/live/manual refreshes
//   const [error, setError]   = useState<string | null>(null);
//   const [live, setLive]     = useState(false);
//   const [timeZone, setTimeZone] = useState<"UTC" | "IST">("UTC");

//   // Raw filter state
//   const [status,       setStatus]       = useState("");
//   const [endpoint,     setEndpoint]     = useState("");
//   const [userType,     setUserType]     = useState("");
//   const [method,       setMethod]       = useState("");
//   const [schoolCode,   setSchoolCode]   = useState("");
//   const [familyCode,   setFamilyCode]   = useState("");
//   const [login,        setLogin]        = useState("");
//   const [priority,     setPriority]     = useState("");
//   const [actionStatus, setActionStatus] = useState("");
//   const [dateFrom,     setDateFrom]     = useState(() => getDefaultDateRange().from);
//   const [dateTo,       setDateTo]       = useState(() => getDefaultDateRange().to);

//   // Debounced (500ms) — avoids hammering the API on every keystroke
//   const dStatus       = useDebounce(status,       500);
//   const dEndpoint     = useDebounce(endpoint,     500);
//   const dUserType     = useDebounce(userType,     500);
//   const dMethod       = useDebounce(method,       500);
//   const dSchoolCode   = useDebounce(schoolCode,   500);
//   const dFamilyCode   = useDebounce(familyCode,   500);
//   const dLogin        = useDebounce(login,        500);
//   const dPriority     = useDebounce(priority,     500);
//   const dActionStatus = useDebounce(actionStatus, 500);
//   const dDateFrom      = useDebounce(dateFrom,     500);
//   const dDateTo        = useDebounce(dateTo,       500);

//   const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
//   const hasLoadedOnce = useRef(false);

//   const buildParams = (): Record<string, string | number> => {
//     const p: Record<string, string | number> = {};
//     if (dStatus)       p.status        = dStatus;
//     if (dEndpoint)     p.endpoint      = dEndpoint;
//     if (dUserType)     p.user_type     = dUserType;
//     if (dMethod)       p.method        = dMethod;
//     if (dSchoolCode)   p.school_code   = dSchoolCode;
//     if (dFamilyCode)   p.family_code   = dFamilyCode;
//     if (dLogin)        p.login         = dLogin;
//     if (dPriority)     p.priority      = dPriority;
//     if (dActionStatus) p.action_status = dActionStatus;
//     if (dDateFrom)      p.date_from     = dDateFrom;
//     if (dDateTo)        p.date_to       = dDateTo;
//     return p;
//   };

//   // After the first successful load, every subsequent call (filters, manual
//   // refresh, or live polling) is a silent background refresh — the table
//   // stays on screen and only the small "updating…" indicator shows, instead
//   // of swapping in the full-page loader.
//   const load = () => {
//     if (!hasLoadedOnce.current) {
//       setLoading(true);
//     } else {
//       setRefreshing(true);
//     }
//       .then((res) => { setLogs(res.logs); setTotal(res.total); setError(null); })
//       .catch((e) => setError(e.message))
//       .finally(() => {
//         hasLoadedOnce.current = true;
//         setLoading(false);
//         setRefreshing(false);
//       });
//   };

//   // Re-fetch when debounced filters change
//   useEffect(() => {
//     load();
//   }, [dStatus, dEndpoint, dUserType, dMethod, dSchoolCode, dFamilyCode, dLogin, dPriority, dActionStatus, dDateFrom, dDateTo]); // eslint-disable-line

//   // Live polling — silent background refresh, no full-page reload
//   useEffect(() => {
//     if (live) {
//       intervalRef.current = setInterval(() => load(), 5000);
//     } else {
//       if (intervalRef.current) clearInterval(intervalRef.current);
//     }
//     return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
//   }, [live, dStatus, dEndpoint, dUserType, dMethod, dSchoolCode, dFamilyCode, dLogin, dPriority, dActionStatus, dDateFrom, dDateTo]); // eslint-disable-line

//   const formatDateTime = (dateString: string) => {
//     const date = new Date(dateString);
//     if (timeZone === "IST") {
//       return new Date(date.getTime() + 5.5 * 3600_000).toLocaleString("en-IN", { hour12: true });
//     }
//     return date.toLocaleString("en-US", { hour12: true }) + " UTC";
//   };

//   const clearFilters = () => {
//     setStatus(""); setEndpoint(""); setUserType(""); setMethod("");
//     setSchoolCode(""); setFamilyCode(""); setLogin("");
//     setPriority(""); setActionStatus("");
//     setDateFrom(""); setDateTo("");
//   };


//   const downloadExcel = () => {
//   const exportData = logs.map((log) => ({
//     DateTime: formatDateTime(log.datetime),
//     School: log.school_code || "",
//     Family: log.family_code || "",
//     Login: log.login || "",
//     UserType: log.user_type || "",
//     Method: log.method || "",
//     Endpoint: log.endpoint || "",
//     Status: log.status || "",
//     StatusCode: log.status_code || "",
//     ResponseTimeMs: log.response_time_ms || "",
//     Priority: log.priority || "",
//     ActionStatus: log.action_status || "",
//   }));

//   const worksheet = XLSX.utils.json_to_sheet(exportData);
//   const workbook = XLSX.utils.book_new();

//   XLSX.utils.book_append_sheet(workbook, worksheet, "Logs");

//   XLSX.writeFile(
//     workbook,
//     `logs_${new Date().toISOString().slice(0, 10)}.xlsx`
//   );
// };

//   if (loading) return <Loader />;
//   if (error)   return <ErrorMsg msg={error} onRetry={() => load()} />;

//   return (
//     <div>
//       <style>{`
//         @keyframes pulse {
//           0%, 100% { opacity: 1; transform: scale(1); }
//           50% { opacity: 0.4; transform: scale(0.7); }
//         }
//       `}</style>
//       <PageHeader title="Live Log Feed" subtitle="Every API call logged in real time" />

//       {/* Toolbar */}
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, flexWrap: "wrap", gap: 8 }}>
//         <span style={{ fontSize: 13, color: "var(--muted)", display: "flex", alignItems: "center", gap: 6 }}>
//           Showing {logs.length} of {total.toLocaleString()} logs
//           {refreshing && (
//             <span style={{ fontSize: 11, color: "var(--muted)", opacity: 0.7 }}>· updating…</span>
//           )}
//         </span>
//         <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
//           {/* Date range */}
//           <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//             <span style={{ fontSize: 12, color: "var(--muted)" }}>From:</span>
//             <input
//               type="date"
//               value={dateFrom}
//               onChange={(e) => setDateFrom(e.target.value)}
//               max={dateTo || undefined}
//               style={{ ...filterInputStyle, padding: "6px 10px", width: "auto" }}
//             />
//             <span style={{ fontSize: 12, color: "var(--muted)" }}>To:</span>
//             <input
//               type="date"
//               value={dateTo}
//               onChange={(e) => setDateTo(e.target.value)}
//               min={dateFrom || undefined}
//               style={{ ...filterInputStyle, padding: "6px 10px", width: "auto" }}
//             />
//           </div>
//           {/* Timezone */}
//           <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//             <span style={{ fontSize: 12, color: "var(--muted)" }}>Time Zone:</span>
//             <select
//               value={timeZone}
//               onChange={(e) => setTimeZone(e.target.value as "UTC" | "IST")}
//               style={{ ...filterInputStyle, padding: "6px 10px" }}
//             >
//               <option value="UTC">UTC</option>
//               <option value="IST">India (UTC +5:30)</option>
//             </select>
//           </div>
//           <button
//   onClick={downloadExcel}
//   style={{
//     ...refreshBtnStyle,
//     background: "#16a34a",
//     color: "#fff",
//   }}
// >
//   ⬇ Download Excel
// </button>
//           <button
//             onClick={() => setLive((v) => !v)}
//             style={{
//               ...refreshBtnStyle,
//               background: live ? "var(--success)" : "var(--surface)",
//               color: live ? "#fff" : "var(--text)",
//               border: "1px solid var(--border)",
//               display: "flex",
//               alignItems: "center",
//               gap: 6,
//             }}
//           >
//             {live && (
//               <span
//                 style={{
//                   width: 6,
//                   height: 6,
//                   borderRadius: "50%",
//                   background: "#fff",
//                   opacity: refreshing ? 1 : 0.5,
//                   animation: refreshing ? "pulse 1s ease-in-out infinite" : "none",
//                 }}
//               />
//             )}
//             {live ? "Live" : "○ Live off"}
//           </button>
//           <button onClick={clearFilters} style={{ ...refreshBtnStyle, background: "var(--surface)", color: "var(--text)", border: "1px solid var(--border)" }}>
//             Clear Filters
//           </button>
//           <button onClick={() => load()} style={refreshBtnStyle}>↻ Refresh</button>
//         </div>
//       </div>

//       {/* Table */}
//       <div style={{ background: "var(--surface)", borderRadius: 10, border: "1px solid var(--border)", overflow: "hidden" }}>
//         <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: 680 }}>
//           <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
//             <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
//               {/* Filter row */}
//               <tr style={{ background: "var(--surface-soft)" }}>
//                 <th style={th}></th>
//                 <th style={th}><FilterInput value={schoolCode} onChange={setSchoolCode} placeholder="School…" /></th>
//                 <th style={th}><FilterInput value={familyCode} onChange={setFamilyCode} placeholder="Family…" /></th>
//                 <th style={th}><FilterInput value={login} onChange={setLogin} placeholder="Login…" /></th>
//                 <th style={th}><FilterSelect value={userType} onChange={setUserType} options={["", "Admin", "Tutor"]} /></th>
//                 <th style={th}><FilterSelect value={method} onChange={setMethod} options={["", "GET", "POST", "PUT", "DELETE"]} /></th>
//                 <th style={th}><FilterInput value={endpoint} onChange={setEndpoint} placeholder="Endpoint…" /></th>
//                 <th style={th}><FilterSelect value={status} onChange={setStatus} options={["", "success", "failed"]} /></th>
//                 <th style={th}></th>
//                 <th style={th}></th>
//                 <th style={th}><FilterSelect value={priority} onChange={setPriority} options={["", "High", "Medium", "Low"]} /></th>
//                 <th style={th}><FilterSelect value={actionStatus} onChange={setActionStatus} options={["", "Pending", "Resolved", "Ignored"]} /></th>
//               </tr>
//               {/* Label row */}
//               <tr style={{ background: "var(--surface-soft)", borderBottom: "1px solid var(--border)" }}>
//                 {["DateTime", "School", "Family", "Login", "User Type", "Method", "Endpoint", "Status", "Code", "RT(ms)", "Priority", "Action"].map((h) => (
//                   <th key={h} style={{ ...th, color: "var(--muted)", fontWeight: 600, letterSpacing: "0.04em" }}>{h}</th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {logs.length === 0 ? (
//                 <tr><td colSpan={12} style={{ padding: 32, textAlign: "center", color: "var(--muted)" }}>No logs found</td></tr>
//               ) : logs.map((log) => (
//                 <tr key={log._id} style={{ borderBottom: "1px solid var(--border)" }}>
//                   <td style={td}>{formatDateTime(log.datetime)}</td>
//                   <td style={td}>{log.school_code || "—"}</td>
//                   <td style={td}>{log.family_code || "—"}</td>
//                   <td style={td}>{log.login       || "—"}</td>
//                   <td style={td}>{log.user_type   || "—"}</td>
//                   <td style={td}><StatusBadge value={log.method}      type="method"      /></td>
//                   <td style={{ ...td, fontFamily: "monospace", maxWidth: 220, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{log.endpoint}</td>
//                   <td style={td}><StatusBadge value={log.status}      type="status"      /></td>
//                   <td style={td}><StatusBadge value={log.status_code} type="status_code" /></td>
//                   <td style={{ ...td, color: log.response_time_ms > 1000 ? "#f87171" : "var(--muted)" }}>{log.response_time_ms}</td>
//                   <td style={td}>{log.priority      ? <StatusBadge value={log.priority}      type="priority"      /> : "—"}</td>
//                   <td style={td}>{log.action_status ? <StatusBadge value={log.action_status} type="action_status" /> : "—"}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LogFeedPage;

// const th: React.CSSProperties = { padding: "8px 12px", textAlign: "left", fontSize: 11, whiteSpace: "nowrap" };
// const td: React.CSSProperties = { padding: "9px 12px", color: "var(--muted)", whiteSpace: "nowrap" };
// const filterInputStyle: React.CSSProperties = {
//   width: "100%",
//   background: "var(--surface)",
//   border: "1px solid var(--border)",
//   borderRadius: 5,
//   padding: "5px 8px",
//   color: "var(--text)",
//   fontSize: 11,
//   outline: "none",
//   boxSizing: "border-box",
// };


import React, { useEffect, useRef, useState } from "react";
import { fetchJson } from "../../services/api";
import { APILog, LogsResponse } from "../types";
import StatusBadge from "../components/StatusBadge";
import { PageHeader, Loader, ErrorMsg, refreshBtnStyle } from "../components/Common";
import * as XLSX from "xlsx";

// ── Default date range presets ───────────────────────────────
const toDateInputValue = (d: Date): string => d.toISOString().slice(0, 10);

type QuickDateRange = "day" | "twoDays" | "week" | "month";

const getDateRange = (unit: QuickDateRange): { from: string; to: string } => {
  const to = new Date();
  const from = new Date();
  if (unit === "day") {
    from.setDate(from.getDate() - 1);
  } else if (unit === "twoDays") {
    from.setDate(from.getDate() - 2);
  } else if (unit === "week") {
    from.setDate(from.getDate() - 7);
  } else {
    from.setMonth(from.getMonth() - 1);
  }
  return { from: toDateInputValue(from), to: toDateInputValue(to) };
};

// Default view when the page first loads — change to getDateRange("week")
// if you'd rather default to the last 7 days instead of the last month.
const getDefaultDateRange = () => getDateRange("day");

// ── Debounce hook ──────────────────────────────────────────
function useDebounce<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

// ── Filter sub-components ──────────────────────────────────
const FilterInput: React.FC<{
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}> = ({ value, onChange, placeholder }) => (
  <input
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    style={filterInputStyle}
  />
);

const FilterSelect: React.FC<{
  value: string;
  onChange: (v: string) => void;
  options: string[];
}> = ({ value, onChange, options }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} style={filterInputStyle}>
    {options.map((o) => (
      <option key={o} value={o}>{o || "All"}</option>
    ))}
  </select>
);

// ── Page ───────────────────────────────────────────────────
const LogFeedPage: React.FC = () => {
  const [logs, setLogs]     = useState<APILog[]>([]);
  const [total, setTotal]   = useState(0);
  const [loading, setLoading]     = useState(true);   // true only for the very first load
  const [refreshing, setRefreshing] = useState(false); // true for filter/live/manual refreshes
  const [error, setError]   = useState<string | null>(null);
  const [live, setLive]     = useState(false);
  const [timeZone, setTimeZone] = useState<"UTC" | "IST">("UTC");

  // Raw filter state
  const [status,       setStatus]       = useState("");
  const [endpoint,     setEndpoint]     = useState("");
  const [userType,     setUserType]     = useState("");
  const [method,       setMethod]       = useState("");
  const [schoolCode,   setSchoolCode]   = useState("");
  const [familyCode,   setFamilyCode]   = useState("");
  const [login,        setLogin]        = useState("");
  const [priority,     setPriority]     = useState("");
  const [actionStatus, setActionStatus] = useState("");
  const [dateFrom,     setDateFrom]     = useState(() => getDefaultDateRange().from);
  const [dateTo,       setDateTo]       = useState(() => getDefaultDateRange().to);
  const [quickRange,   setQuickRange]   = useState<QuickDateRange | null>("day");

  // Debounced (500ms) — avoids hammering the API on every keystroke
  const dStatus       = useDebounce(status,       500);
  const dEndpoint     = useDebounce(endpoint,     500);
  const dUserType     = useDebounce(userType,     500);
  const dMethod       = useDebounce(method,       500);
  const dSchoolCode   = useDebounce(schoolCode,   500);
  const dFamilyCode   = useDebounce(familyCode,   500);
  const dLogin        = useDebounce(login,        500);
  const dPriority     = useDebounce(priority,     500);
  const dActionStatus = useDebounce(actionStatus, 500);
  const dDateFrom      = useDebounce(dateFrom,     500);
  const dDateTo        = useDebounce(dateTo,       500);

  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const hasLoadedOnce = useRef(false);

  const buildParams = (): Record<string, string | number> => {
    const p: Record<string, string | number> = {};
    if (dStatus)       p.status        = dStatus;
    if (dEndpoint)     p.endpoint      = dEndpoint;
    if (dUserType)     p.user_type     = dUserType;
    if (dMethod)       p.method        = dMethod;
    if (dSchoolCode)   p.school_code   = dSchoolCode;
    if (dFamilyCode)   p.family_code   = dFamilyCode;
    if (dLogin)        p.login         = dLogin;
    if (dPriority)     p.priority      = dPriority;
    if (dActionStatus) p.action_status = dActionStatus;
    if (dDateFrom)      p.date_from     = dDateFrom;
    if (dDateTo)        p.date_to       = dDateTo;
    return p;
  };

  // After the first successful load, every subsequent call (filters, manual
  // refresh, or live polling) is a silent background refresh — the table
  // stays on screen and only the small "updating…" indicator shows, instead
  // of swapping in the full-page loader.
  const load = () => {
    if (!hasLoadedOnce.current) {
      setLoading(true);
    } else {
      setRefreshing(true);
    }
    fetchJson<LogsResponse>("/monitor/logs/", buildParams())
      .then((res) => { setLogs(res.logs); setTotal(res.total); setError(null); })
      .catch((e) => setError(e.message))
      .finally(() => {
        hasLoadedOnce.current = true;
        setLoading(false);
        setRefreshing(false);
      });
  };

  // Re-fetch when debounced filters change
  useEffect(() => {
    load();
  }, [dStatus, dEndpoint, dUserType, dMethod, dSchoolCode, dFamilyCode, dLogin, dPriority, dActionStatus, dDateFrom, dDateTo]); // eslint-disable-line

  // Live polling — silent background refresh, no full-page reload
  useEffect(() => {
    if (live) {
      intervalRef.current = setInterval(() => load(), 5000);
    } else {
      if (intervalRef.current) clearInterval(intervalRef.current);
    }
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  }, [live, dStatus, dEndpoint, dUserType, dMethod, dSchoolCode, dFamilyCode, dLogin, dPriority, dActionStatus, dDateFrom, dDateTo]); // eslint-disable-line

  const formatDateTime = (dateString: string) => {
    const date = new Date(dateString);
    if (timeZone === "IST") {
      return new Date(date.getTime() + 5.5 * 3600_000).toLocaleString("en-IN", { hour12: true });
    }
    return date.toLocaleString("en-US", { hour12: true }) + " UTC";
  };

  const clearFilters = () => {
    setStatus(""); setEndpoint(""); setUserType(""); setMethod("");
    setSchoolCode(""); setFamilyCode(""); setLogin("");
    setPriority(""); setActionStatus("");
    const { from, to } = getDefaultDateRange();
    setDateFrom(from); setDateTo(to);
    setQuickRange("day");
  };

  const applyQuickRange = (range: QuickDateRange) => {
    const { from, to } = getDateRange(range);
    setDateFrom(from); setDateTo(to);
    setQuickRange(range);
  };


  const downloadExcel = () => {
  const exportData = logs.map((log) => ({
    DateTime: formatDateTime(log.datetime),
    School: log.school_code || "",
    Family: log.family_code || "",
    Login: log.login || "",
    UserType: log.user_type || "",
    Method: log.method || "",
    Endpoint: log.endpoint || "",
    Status: log.status || "",
    StatusCode: log.status_code || "",
    ResponseTimeMs: log.response_time_ms || "",
    Priority: log.priority || "",
    ActionStatus: log.action_status || "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Logs");

  XLSX.writeFile(
    workbook,
    `logs_${new Date().toISOString().slice(0, 10)}.xlsx`
  );
};

  if (loading) return <Loader />;
  if (error)   return <ErrorMsg msg={error} onRetry={() => load()} />;

  return (
    <div>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.4; transform: scale(0.7); }
        }
      `}</style>
      <PageHeader title="Live Log Feed" subtitle="Every API call logged in real time" />

      {/* Toolbar */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, flexWrap: "wrap", gap: 8 }}>
        <span style={{ fontSize: 13, color: "var(--muted)", display: "flex", alignItems: "center", gap: 6 }}>
          Showing {logs.length} of {total.toLocaleString()} logs
          {refreshing && (
            <span style={{ fontSize: 11, color: "var(--muted)", opacity: 0.7 }}>· updating…</span>
          )}
        </span>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
          {/* Date range */}
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ fontSize: 12, color: "var(--muted)" }}>From:</span>
            <input
              type="date"
              value={dateFrom}
              onChange={(e) => { setDateFrom(e.target.value); setQuickRange(null); }}
              max={dateTo || undefined}
              style={{ ...filterInputStyle, padding: "6px 10px", width: "auto" }}
            />
            <span style={{ fontSize: 12, color: "var(--muted)" }}>To:</span>
            <input
              type="date"
              value={dateTo}
              onChange={(e) => { setDateTo(e.target.value); setQuickRange(null); }}
              min={dateFrom || undefined}
              style={{ ...filterInputStyle, padding: "6px 10px", width: "auto" }}
            />
            <button
              onClick={() => applyQuickRange("day")}
              style={quickRangeButtonStyle(quickRange === "day")}
            >
              1D
            </button>
            <button
              onClick={() => applyQuickRange("twoDays")}
              style={quickRangeButtonStyle(quickRange === "twoDays")}
            >
              2D
            </button>
            <button
              onClick={() => applyQuickRange("week")}
              style={quickRangeButtonStyle(quickRange === "week")}
            >
              1W
            </button>
            <button
              onClick={() => applyQuickRange("month")}
              style={quickRangeButtonStyle(quickRange === "month")}
            >
              1M
            </button>
          </div>
          {/* Timezone */}
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ fontSize: 12, color: "var(--muted)" }}>Time Zone:</span>
            <select
              value={timeZone}
              onChange={(e) => setTimeZone(e.target.value as "UTC" | "IST")}
              style={{ ...filterInputStyle, padding: "6px 10px" }}
            >
              <option value="UTC">UTC</option>
              <option value="IST">India (UTC +5:30)</option>
            </select>
          </div>
          <button
            onClick={downloadExcel}
            style={{
              ...refreshBtnStyle,
              background: "#16a34a",
              color: "#fff",
            }}
          >
            ⬇ Download Excel
          </button>
          <button
            onClick={() => setLive((v) => !v)}
            style={{
              ...refreshBtnStyle,
              background: live ? "var(--success)" : "var(--surface)",
              color: live ? "#fff" : "var(--text)",
              border: "1px solid var(--border)",
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            {live && (
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  background: "#fff",
                  opacity: refreshing ? 1 : 0.5,
                  animation: refreshing ? "pulse 1s ease-in-out infinite" : "none",
                }}
              />
            )}
            {live ? "Live" : "○ Live off"}
          </button>
          <button onClick={clearFilters} style={{ ...refreshBtnStyle, background: "var(--surface)", color: "var(--text)", border: "1px solid var(--border)" }}>
            Clear Filters
          </button>
          <button onClick={() => load()} style={refreshBtnStyle}>↻ Refresh</button>
        </div>
      </div>

      {/* Table */}
      <div style={{ background: "var(--surface)", borderRadius: 10, border: "1px solid var(--border)", overflow: "hidden" }}>
        <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: 680 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
            <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
              {/* Filter row */}
              <tr style={{ background: "var(--surface-soft)" }}>
                <th style={th}></th>
                <th style={th}><FilterInput value={schoolCode} onChange={setSchoolCode} placeholder="School…" /></th>
                <th style={th}><FilterInput value={familyCode} onChange={setFamilyCode} placeholder="Family…" /></th>
                <th style={th}><FilterInput value={login} onChange={setLogin} placeholder="Login…" /></th>
                <th style={th}><FilterSelect value={userType} onChange={setUserType} options={["", "Admin", "Tutor"]} /></th>
                <th style={th}><FilterSelect value={method} onChange={setMethod} options={["", "GET", "POST", "PUT", "DELETE"]} /></th>
                <th style={th}><FilterInput value={endpoint} onChange={setEndpoint} placeholder="Endpoint…" /></th>
                <th style={th}><FilterSelect value={status} onChange={setStatus} options={["", "success", "failed"]} /></th>
                <th style={th}></th>
                <th style={th}></th>
                <th style={th}><FilterSelect value={priority} onChange={setPriority} options={["", "High", "Medium", "Low"]} /></th>
                <th style={th}><FilterSelect value={actionStatus} onChange={setActionStatus} options={["", "Pending", "Resolved", "Ignored"]} /></th>
              </tr>
              {/* Label row */}
              <tr style={{ background: "var(--surface-soft)", borderBottom: "1px solid var(--border)" }}>
                {["DateTime", "School", "Family", "Login", "User Type", "Method", "Endpoint", "Status", "Code", "RT(ms)", "Priority", "Action"].map((h) => (
                  <th key={h} style={{ ...th, color: "var(--muted)", fontWeight: 600, letterSpacing: "0.04em" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 ? (
                <tr><td colSpan={12} style={{ padding: 32, textAlign: "center", color: "var(--muted)" }}>No logs found</td></tr>
              ) : logs.map((log) => (
                <tr key={log._id} style={{ borderBottom: "1px solid var(--border)" }}>
                  <td style={td}>{formatDateTime(log.datetime)}</td>
                  <td style={td}>{log.school_code || "—"}</td>
                  <td style={td}>{log.family_code || "—"}</td>
                  <td style={td}>{log.login       || "—"}</td>
                  <td style={td}>{log.user_type   || "—"}</td>
                  <td style={td}><StatusBadge value={log.method}      type="method"      /></td>
                  <td style={{ ...td, fontFamily: "monospace", maxWidth: 220, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{log.endpoint}</td>
                  <td style={td}><StatusBadge value={log.status}      type="status"      /></td>
                  <td style={td}><StatusBadge value={log.status_code} type="status_code" /></td>
                  <td style={{ ...td, color: log.response_time_ms > 1000 ? "#f87171" : "var(--muted)" }}>{log.response_time_ms}</td>
                  <td style={td}>{log.priority      ? <StatusBadge value={log.priority}      type="priority"      /> : "—"}</td>
                  <td style={td}>{log.action_status ? <StatusBadge value={log.action_status} type="action_status" /> : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LogFeedPage;

const th: React.CSSProperties = { padding: "8px 12px", textAlign: "left", fontSize: 11, whiteSpace: "nowrap" };
const td: React.CSSProperties = { padding: "9px 12px", color: "var(--muted)", whiteSpace: "nowrap" };
const filterInputStyle: React.CSSProperties = {
  width: "100%",
  background: "var(--surface)",
  border: "1px solid var(--border)",
  borderRadius: 5,
  padding: "5px 8px",
  color: "var(--text)",
  fontSize: 11,
  outline: "none",
  boxSizing: "border-box",
};

const quickRangeButtonStyle = (active: boolean): React.CSSProperties => ({
  ...refreshBtnStyle,
  padding: "6px 10px",
  background: active ? "#2563eb" : "var(--surface)",
  color: active ? "#ffffff" : "var(--text)",
  border: active ? "1px solid #2563eb" : "1px solid var(--border)",
  boxShadow: active ? "0 2px 5px rgba(37, 99, 235, 0.28)" : "none",
});
